document.addEventListener('DOMContentLoaded', function () {
  const loadMoreWrapper = document.querySelector(
    '[data-load-more-wrapper]'
  );

  if (!loadMoreWrapper) {
    return;
  }

  const button = loadMoreWrapper.querySelector(
    '[data-load-more]'
  );

  const productGrid = document.querySelector(
    '#product-grid'
  );

  if (!button || !productGrid) {
    return;
  }

  let isLoading = false;

  button.addEventListener('click', async function () {
    if (isLoading) {
      return;
    }

    const nextPage = parseInt(
      button.dataset.nextPage,
      10
    );

    const totalPages = parseInt(
      loadMoreWrapper.dataset.totalPages,
      10
    );

    const sectionId =
      loadMoreWrapper.dataset.sectionId;

    if (
      !nextPage ||
      !totalPages ||
      nextPage > totalPages
    ) {
      loadMoreWrapper.remove();
      return;
    }

    isLoading = true;

    const buttonText =
      button.querySelector(
        '.load-more-button__text'
      );

    const loadingText =
      button.querySelector(
        '.load-more-button__loading'
      );

    button.disabled = true;
    button.setAttribute(
      'aria-busy',
      'true'
    );

    if (buttonText) {
      buttonText.hidden = true;
    }

    if (loadingText) {
      loadingText.hidden = false;
    }

    try {
      const url = new URL(
        window.location.href
      );

      url.searchParams.set(
        'page',
        nextPage
      );

      url.searchParams.set(
        'section_id',
        sectionId
      );

      const response = await fetch(
        url.toString(),
        {
          method: 'GET',
          headers: {
            'X-Requested-With':
              'XMLHttpRequest'
          }
        }
      );

      if (!response.ok) {
        throw new Error(
          'Unable to load products.'
        );
      }

      const html =
        await response.text();

      const parser =
        new DOMParser();

      const newDocument =
        parser.parseFromString(
          html,
          'text/html'
        );

      const newProductGrid =
        newDocument.querySelector(
          '#product-grid'
        );

      const newLoadMoreWrapper =
        newDocument.querySelector(
          '[data-load-more-wrapper]'
        );

      if (!newProductGrid) {
        throw new Error(
          'Product grid was not found.'
        );
      }

      /*
       * Append only the new product cards.
       */
      Array.from(
        newProductGrid.children
      ).forEach(function (product) {
        productGrid.appendChild(
          product
        );
      });

      /*
       * Update animation order.
       */
      productGrid
        .querySelectorAll('.grid__item')
        .forEach(function (
          product,
          index
        ) {
          product.style.setProperty(
            '--animation-order',
            index + 1
          );
        });

      /*
       * Update pagination state.
       */
      if (
        newLoadMoreWrapper
      ) {
        const newNextPage =
          newLoadMoreWrapper.dataset
            .nextPage;

        if (
          newNextPage &&
          parseInt(
            newNextPage,
            10
          ) <= totalPages
        ) {
          button.dataset.nextPage =
            newNextPage;
        } else {
          loadMoreWrapper.remove();
        }
      } else {
        loadMoreWrapper.remove();
      }

      /*
       * Update browser URL.
       */
      const browserUrl =
        new URL(
          window.location.href
        );

      browserUrl.searchParams.set(
        'page',
        nextPage
      );

      window.history.replaceState(
        {},
        '',
        browserUrl.toString()
      );

    } catch (error) {
      console.error(
        'Load More Error:',
        error
      );
    }

    /*
     * Restore button.
     */
    if (
      loadMoreWrapper.isConnected
    ) {
      button.disabled = false;

      button.removeAttribute(
        'aria-busy'
      );

      if (buttonText) {
        buttonText.hidden = false;
      }

      if (loadingText) {
        loadingText.hidden = true;
      }
    }

    isLoading = false;
  });
});